<template>
  <div class="login mt-4">
    <GoogleSignIn
      @authenticated="handleAuthentication"
      @signed-out="handleSignOut"
    />
  </div>
</template>

<script>
import GoogleSignIn from './GoogleSignIn'

export default {
  name: 'SignIn',
  components: {
    GoogleSignIn,
  },
  metaInfo: {
    title: 'Sign In',
  },
  methods: {
    handleAuthentication(userProfile) {
      console.log('User authenticated:', userProfile)

      // Check if user is already authenticated in store
      if (this.$store.getters.isAuthenticated) {
        // Redirect to dashboard or stored redirect path
        const redirectPath = this.$store.getters.signInRedirect || '/dashboard'
        this.$router.push(redirectPath)
      }

      this.$notify({
        title: 'Authentication Successful',
        text: `Welcome, ${userProfile.name}!`,
        type: 'success',
      })
    },

    handleSignOut() {
      console.log('User signed out')
      // Dispatch logout to consolidated user store
      this.$store.dispatch('logout')

      this.$notify({
        title: 'Signed Out',
        text: 'You have been signed out successfully.',
        type: 'info',
      })
    },
  },
}
</script>

<style scoped></style>
